module.exports = __webpack_public_path__ + "img/15.509a52fe.jpeg";